export const ApiBaseUrl = process.env.REACT_APP_API_BASE_URL
export const UiBaseUrl = process.env.REACT_APP_UI_BASE_URL

export const ONE_DRIVE_CLIENT_ID = process.env.REACT_APP_ONE_DRIVE_CLIENT_ID
export const ONE_DRIVE_SECRET_VERIFIER_CODE = process.env.REACT_APP_ONE_DRIVE_SECRET_VERIFIER_CODE

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
export const GOOGLE_DEVELOPER_KEY = process.env.REACT_APP_GOOGLE_DEVELOPER_KEY


// console.log("React Application Base", {
//   ApiBaseUrl,
//   UiBaseUrl
// })

export const signupApi = "/v1/user/login";
export const otpApi = "/v1/user/verifyOtp";
export const createProjectApi = "/v1/user/addProject";
export const getProjectListApi = "/v1/user/getProjectList";
export const getChatHistoryApi = "/v1/user/getChatHistory";
export const askQuestionApi = "/v1/user/askQuestion";
export const googleLoginApi = "/v1/user/signUpGoogle";
export const facebookLoginApi = "/v1/user/signUpFacebook";
export const pdfUploadApi = "/v1/user/store-pdf";
export const pdfUploadApiDrive = "/v1/user/store-pdf-drive";
export const askQuestionFromPdfApi = "/v1/user/get-pdf-answer";
export const getDocumentListApi = "/v1/user/getChatList";
export const getCountryListApi = "/v1/user/getCountries";
export const getStateListApi = "/v1/user/getStates";
export const getCityListApi = "/v1/user/getCities";
export const createCompanyApi = "/v1/user/createCompany";
export const getCompanyListApi = "/v1/user/getCompany";
export const getProfileDataApi = "/v1/user/profile";
export const editProfileApi = "/v1/user/updateProfile";
export const getProjectApi = "/v1/user/getProject?projectId=";
export const updateProjectApi = "/v1/user/updateProject";
export const deleteProjectFileApi = "/v1/user/deleteProjectChat";

export const getGoogleoAuthUrlDataApi = "/v1/user/google/auth/url";
export const getGoogleoAuthAccessTokenDataApi = "/v1/user/google/auth/access/token";
export const getGoogleoAuthAccessTokenRevokeApi = "/v1/user/google/auth/access/revoke";

export const getOneDriveoAuthAccessTokenDataApi = "/v1/user/onedrive/auth/access/token";
export const getOneDriveoAuthAccessTokenRevokeApi = "/v1/user/onedrive/auth/access/revoke";


export const getQuestinDetailApi = "/v1/user/questionDetail/";

export const getAllEmployeeApi = "/v1/user/employee/all";
export const removeEmployeeApi = "/v1/user/employee/remove/";
export const updateEmployeeApi = "/v1/user/employee/update";
export const addEmployeeApi = "/v1/user/employee/add";

export const getAllSubscriptionPlansApi = "/v1/user/subscription-plans/all";
export const createCheckoutSessionApi = '/v1/subscription/create-checkout-session'
export const createCheckoutSessionOneTimeApi = '/v1/subscription/create-checkout-session/one-time-payment'
export const cancelSubscriptionPlanApi = '/v1/subscription/cancel'

export const getAllSubscriptionApi = '/v1/user/employee/subscriptions/all'
export const getAllPayemntsApi = '/v1/user/employee/payments/all'


export const forgotPasswordApi = "/v1/user/forgotPassword";
export const resetPasswordApi = "/v1/user/resetPassword";

export const subscriptionSessionVerifyApi = "/v1/subscription/verify-session";

export const DISCOVERY_DOCS = [
  "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest",
];
export const SCOPES = "https://www.googleapis.com/auth/drive.readonly";

export const saveIntakeAnswersApi = "/v1/user/intake/save";
export const getIntakeAnswersApi = "/v1/user/intake/answers";
export const uploadSurveyPdfApi = "/v1/user/intake/upload-survey";



export const submitClinicalReviewApi    = "/v1/clinical/review";
export const getPendingReviewsApi       = "/v1/clinical/reviews/pending";
export const getClinicalReviewByIdApi   = "/v1/clinical/review/";
export const getReviewsByProjectApi     = "/v1/clinical/reviews/project/";
export const getClinicalAuditTrailApi   = "/v1/clinical/audit/";
export const quickAssessApi = "/v1/user/quick-assess";
